const miles = meters => {
  let m = meters / 1609.344
  return Number(Math.round(m + 'e2') + 'e-2')
}

export default miles